import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Initial state
const initialState = {
  discounts: [], // Deals stored in MongoDB
  regularDiscounts: [], // Unmodified discounts from the API
  loading: false,
  error: null,
};

// Async thunk for fetching discounts
export const fetchDiscounts = createAsyncThunk(
  'pos/fetchDiscounts',
  async (businessId, { rejectWithValue }) => {
    try {
      const response = await axios.get(`https://api.aweioio.com/api/fetch-discounts?businessId=${businessId}`);
      return {
        syncedDeals: response.data.syncedDeals,
        regularDiscounts: response.data.regularDiscounts,
      };
    } catch (error) {
      console.error("Error fetching discounts:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Create the POS slice
const POSSlice = createSlice({
  name: 'pos',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDiscounts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDiscounts.fulfilled, (state, action) => {
        state.loading = false;
        state.discounts = action.payload.syncedDeals; // Update synced deals
        state.regularDiscounts = action.payload.regularDiscounts; // Update regular discounts
      })
      .addCase(fetchDiscounts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Error fetching discounts';
      });
  },
});

// Export the reducer to use in the store
export default POSSlice.reducer;
